(() => {
  if (window.mcImageViewerBound) return;
  window.mcImageViewerBound = true;
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-mc-image-zoom]');
    if (!opener || opener.disabled || !opener.dataset.mcImageZoom) return;
    const viewer = document.getElementById('ProductModal-cart-image');
    if (!viewer || typeof viewer.show !== 'function') return;
    event.preventDefault();
    const image = viewer.querySelector('img[data-media-id="cart-image"]');
    image.src = opener.dataset.mcImageZoom;
    image.alt = opener.dataset.mcImageAlt || opener.querySelector('img')?.alt || '';
    image.dataset.fullWidth = opener.dataset.mcImageWidth || '2048';
    image.removeAttribute('srcset');
    opener.dataset.mediaId = 'cart-image';
    viewer.show(opener);
  });
  document.body.addEventListener('modalClosed',()=>{
    const active=document.activeElement;
    const drawer=active?.closest('mc-cart-drawer:not([hidden]) [role=dialog]');
    const popup=active?.closest('#mc-atc.is-open .mc-atc__box');
    if(drawer || popup)trapFocus(drawer || popup,active);
  });
})();
